// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
let Sentry = require("../../reason/Sentry.bs.js");
let TanDate = require("../../reason/common/types/TanDate.bs.js");
let DateFns = require("date-fns");
let ViewStack = require("../../reason/common/ViewStack.bs.js");
let PageUITitle = require("../../components/PageTitle/PageUITitle.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let LoggedInAgent = require("../../reason/common/UserSession/LoggedInAgent.bs.js");
let MarkupHelpers = require("../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let ErrorComponent = require("../../reason/common/Error/ErrorComponent.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let MyDraftsWidgetRelay = require("../drafts/MyDraftsWidgetRelay.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let MyClientsWidgetRelay = require("../client/myClientsWidget/MyClientsWidgetRelay.bs.js");
let ReactErrorBoundary = require("react-error-boundary");
let MySharedPostsWidgetRelay = require("../sharing/sharedPosts/MySharedPostsWidgetRelay.bs.js");
let MyClientsWidgetQueryParams = require("../client/myClientsWidget/MyClientsWidgetQueryParams.bs.js");
let MyBroadcastMessagesWidgetRelay = require("../messages/MyBroadcastMessagesWidgetRelay.bs.js");
let MyDashboardPageRelayQuery_graphql = require("../../__generated__/MyDashboardPageRelayQuery_graphql.bs.js");

let convertVariables = MyDashboardPageRelayQuery_graphql.Internal.convertVariables;

let convertResponse = MyDashboardPageRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = MyDashboardPageRelayQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, MyDashboardPageRelayQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, MyDashboardPageRelayQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(MyDashboardPageRelayQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(MyDashboardPageRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(MyDashboardPageRelayQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(MyDashboardPageRelayQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function MyDashboardPageRelay$Greet(props) {
  let hour = DateFns.getHours(TanDate.now());
  let greeting = hour > 5 && hour < 12 ? "Good morning" : (
      hour >= 12 && hour < 17 ? "Good afternoon" : (
          hour >= 17 && hour < 20 ? "Good evening" : "Hi"
        )
    );
  return JsxRuntime.jsx(PageUITitle.make, {
    title: greeting + ` <b>` + props.name + `</b>`
  });
}

let Greet = {
  make: MyDashboardPageRelay$Greet
};

function MyDashboardPageRelay$ErrorState(props) {
  return JsxRuntime.jsx(MarkupHelpers.Container.make, {
    children: JsxRuntime.jsx(ErrorComponent.make, {
      message: "There was a problem loading your data. Please refresh or try again later."
    })
  });
}

let ErrorState = {
  make: MyDashboardPageRelay$ErrorState
};

function MyDashboardPageRelay$LoadingState(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Loader.make, {}),
    className: "flex justify-center items-center grow h-full"
  });
}

let LoadingState = {
  make: MyDashboardPageRelay$LoadingState
};

function MyDashboardPageRelay$default(props) {
  let match = MyClientsWidgetQueryParams.use();
  let queryParams = match[0];
  let match$1 = React.useState(() => queryParams.clientSearchTerm);
  let data = use({
    searchTerm: match$1[0],
    viewId: "Dashboard"
  }, undefined, undefined, undefined);
  let currenUserInfo = UserSession.useCurrentUserInfo();
  let tmp;
  if (currenUserInfo !== undefined) {
    switch (currenUserInfo.__typename) {
      case "Agent" :
      case "RegisteredClient" :
        tmp = currenUserInfo.firstName;
        break;
      case "__unselected" :
        tmp = "";
        break;
    }
  } else {
    tmp = "";
  }
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
    FallbackComponent: _error => JsxRuntime.jsx(MyDashboardPageRelay$ErrorState, {}),
    children: JsxRuntime.jsx(LoggedInAgent.Provider.make, {
      loaderComponent: JsxRuntime.jsx(MyDashboardPageRelay$LoadingState, {}),
      children: JsxRuntime.jsxs(MarkupHelpers.Container.make, {
        children: [
          JsxRuntime.jsx(MyDashboardPageRelay$Greet, {
            name: tmp
          }),
          JsxRuntime.jsxs(ViewStack.make, {
            children: [
              JsxRuntime.jsx(React.Suspense, {
                children: JsxRuntime.jsx(MyClientsWidgetRelay.make, {
                  query: data.fragmentRefs,
                  viewMoreMode: "ShowAllButton"
                }),
                fallback: JsxRuntime.jsx(MyDashboardPageRelay$LoadingState, {})
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(React.Suspense, {
                  children: JsxRuntime.jsx(MyDraftsWidgetRelay.make, {
                    query: data.fragmentRefs,
                    viewMoreMode: "ShowAllButton"
                  }),
                  fallback: JsxRuntime.jsx(MyDashboardPageRelay$LoadingState, {})
                }),
                id: "drafts"
              }),
              JsxRuntime.jsx(React.Suspense, {
                children: JsxRuntime.jsx(MyBroadcastMessagesWidgetRelay.make, {
                  query: data.fragmentRefs,
                  viewMoreMode: "ShowAllButton"
                }),
                fallback: JsxRuntime.jsx(MyDashboardPageRelay$LoadingState, {})
              }),
              JsxRuntime.jsx(React.Suspense, {
                children: JsxRuntime.jsx(MySharedPostsWidgetRelay.make, {
                  query: data.fragmentRefs,
                  viewMoreMode: "ShowAllButton"
                }),
                fallback: JsxRuntime.jsx(MyDashboardPageRelay$LoadingState, {})
              })
            ]
          })
        ]
      })
    }),
    onError: error => Sentry.captureException(error, "MyDashboardPageRelay.res", undefined, undefined, undefined)
  });
}

let QueryParams;

let PageTitle;

let Container;

let $$default = MyDashboardPageRelay$default;

exports.QueryParams = QueryParams;
exports.Query = Query;
exports.PageTitle = PageTitle;
exports.Container = Container;
exports.Greet = Greet;
exports.ErrorState = ErrorState;
exports.LoadingState = LoadingState;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
